import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  const lastUpdate = "9 janvier 2026";
  const [expandedSection, setExpandedSection] = useState(null);

  const sections = [
    {
      title: "1. Acceptation des conditions",
      content: `En accédant à DJAMANN ou en l'utilisant, vous acceptez d'être lié par ces Conditions d'Utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre plateforme.

DJAMANN est une plateforme innovante qui permet :
• De lancer des projets entrepreneuriaux sans capital initial
• De collaborer avec d'autres personnes partageant les mêmes ambitions
• De proposer ou trouver des services professionnels
• De gérer des équipes et des finances de projet
• D'accéder à un écosystème complet de modules business

La plateforme fonctionne sur un système d'abonnement modulaire permettant d'activer uniquement les fonctionnalités dont vous avez besoin.`
    },
    {
      title: "2. Éligibilité",
      content: `Pour utiliser DJAMANN, vous devez :
• Avoir au moins 16 ans
• Résider en Côte d'Ivoire (d'autres pays seront disponibles prochainement)
• Fournir des informations exactes lors de l'inscription
• Ne pas avoir été précédemment banni de la plateforme
• Disposer d'une adresse email valide

Les mineurs de 16 à 18 ans peuvent utiliser la plateforme sous la responsabilité de leurs parents ou tuteurs légaux. Certaines fonctionnalités financières peuvent être restreintes pour les mineurs.`
    },
    {
      title: "3. Rôle de DJAMANN",
      content: `DJAMANN agit en tant qu'intermédiaire technologique entre les utilisateurs. Nous fournissons :

🔧 Outils de gestion :
• Création et gestion de projets
• Tableau de bord auteur complet
• Suivi des tâches et missions
• Gestion des collaborateurs et équipes

💰 Services financiers :
• Système de paiement sécurisé multi-moyens
• Suivi des revenus et dépenses par projet
• Paiement des collaborateurs
• Rapports financiers détaillés

🛍️ E-commerce :
• Création de boutiques en ligne
• Gestion des services et produits
• Demandes de services personnalisées

📢 Communication :
• Système de notifications
• Messagerie intégrée
• Feed d'opportunités "Pour Toi"

DJAMANN n'est PAS partie prenante dans les accords conclus entre utilisateurs. Toutes les clauses, conditions de collaboration, répartition des tâches et des revenus sont discutées et décidées directement entre les parties concernées.`
    },
    {
      title: "4. Types de comptes et rôles",
      content: `DJAMANN propose un système de rôles flexible :

👤 Utilisateur standard :
• Consulter les opportunités (feed "Pour Toi")
• Postuler à des missions et projets
• Proposer ses services
• Créer un profil professionnel

✍️ Auteur / Gérant de projet :
• Créer et gérer des projets illimités
• Publier des offres (emploi, stage, collaboration, prestation, partenariat)
• Recruter et gérer des collaborateurs
• Assigner des tâches et suivre l'avancement
• Gérer les finances du projet
• Créer une boutique de services

👑 Administrateur (réservé à l'équipe DJAMANN) :
• Gérer la plateforme
• Modérer les contenus
• Gérer les abonnements et modules

Un même utilisateur peut cumuler les rôles d'utilisateur standard et d'auteur. Le passage au rôle auteur nécessite un abonnement actif.`
    },
    {
      title: "5. Système d'abonnement et modules",
      content: `DJAMANN fonctionne avec un système d'abonnement modulaire :

📦 Modules disponibles (liste non exhaustive) :
• Gestion de projets
• Gestion des finances
• Boutique et services
• Gestion des collaborateurs
• Rapports et statistiques
• Et d'autres modules en développement...

💳 Fonctionnement :
• Chaque module a un prix mensuel
• Vous ne payez que les modules que vous utilisez
• Les modules s'activent instantanément après paiement
• Vous pouvez ajouter ou retirer des modules à tout moment

🎁 Modules gratuits :
Certains modules de base peuvent être offerts gratuitement pour permettre à tous de démarrer.

La liste complète des modules et leurs tarifs est disponible dans la section "Abonnements" de votre tableau de bord.`
    },
    {
      title: "6. Commissions et frais",
      content: `DJAMANN applique la politique de frais suivante :

✅ GRATUIT :
• Inscription sur la plateforme
• Création de compte
• Consultation du feed "Pour Toi"
• Candidature aux offres

💰 Abonnements modules :
• Prix variable selon les modules choisis
• Facturation mensuelle
• Possibilité d'extension (durée personnalisée)

📊 Commission plateforme :
• 3% des recettes mensuelles des projets
• Applicable uniquement aux auteurs/gérants
• Prélevée automatiquement en fin de mois
• Permet de maintenir et améliorer la plateforme

Les transactions directes entre collaborateurs (paiements de salaires, parts de revenus) ne sont pas soumises à la commission de 3%.`
    },
    {
      title: "7. Responsabilités des utilisateurs",
      content: `En utilisant DJAMANN, vous vous engagez à :

✅ Bonnes pratiques :
• Fournir des informations exactes et à jour
• Respecter vos engagements envers les autres utilisateurs
• Communiquer de manière professionnelle et respectueuse
• Tenir à jour votre profil et vos compétences
• Honorer les missions et collaborations acceptées

❌ Interdictions :
• Utiliser la plateforme à des fins illégales
• Publier du contenu offensant, discriminatoire ou illégal
• Usurper l'identité d'une autre personne
• Créer de faux profils ou de faux projets
• Spammer les autres utilisateurs
• Contourner les systèmes de paiement de la plateforme
• Violer la propriété intellectuelle d'autrui

Vous êtes seul responsable de vos interactions et accords avec les autres utilisateurs.`
    },
    {
      title: "8. Projets et collaborations",
      content: `Lors de la création ou participation à un projet :

📋 Création de projet :
• Définissez clairement les objectifs et la catégorie
• Décrivez les rôles recherchés
• Fixez les conditions de collaboration (rémunération, parts, etc.)
• Respectez les lois en vigueur

🤝 Collaboration :
• Les termes sont définis entre les parties
• DJAMANN n'intervient pas dans les négociations
• Utilisez le système de tâches pour suivre l'avancement
• Documentez les accords dans la plateforme

⚠️ En cas de litige :
• Tentez d'abord une résolution à l'amiable
• Utilisez le système de signalement si nécessaire
• DJAMANN peut servir de médiateur sur demande

Nous nous réservons le droit de suspendre ou supprimer des projets qui violent nos conditions.`
    },
    {
      title: "9. Types d'offres",
      content: `DJAMANN permet de publier différents types d'offres :

🤝 Collaboration (Associé) :
Recherche de co-fondateurs ou associés pour un projet. Partage des responsabilités et des revenus selon les termes définis.

💰 Prestation (Freelance) :
Missions ponctuelles rémunérées. Le prestataire exécute une tâche définie contre paiement.

👔 Emploi :
Postes salariés au sein d'un projet. Contrat de travail classique selon la législation ivoirienne.

🎓 Stage :
Opportunités de stage pour étudiants ou personnes en formation. Peut être rémunéré ou non selon les conditions.

🤝 Partenariat :
Recherche de partenaires commerciaux, sponsors ou collaborations inter-entreprises.`
    },
    {
      title: "10. Paiements",
      content: `DJAMANN accepte tous les moyens de paiement disponibles dans la région :

📱 Mobile Money :
• Orange Money
• MTN Money
• Moov Money
• Wave

💳 Autres moyens :
• Cartes bancaires (Visa, Mastercard)
• Virements bancaires
• PayPal (bientôt disponible)

🔒 Sécurité :
• Transactions cryptées SSL
• DJAMANN ne stocke pas vos informations bancaires sensibles
• Partenaires de paiement certifiés
• Historique complet des transactions

Les retraits de fonds sont traités dans un délai de 24 à 72h ouvrées.`
    },
    {
      title: "11. Boutique et services",
      content: `Les auteurs peuvent créer une boutique de services :

🛍️ Fonctionnalités :
• Page boutique publique personnalisée
• Catalogue de services illimité
• Prix et descriptions personnalisables
• Demandes de services personnalisées
• Gestion des commandes

📋 Règles :
• Les services doivent être légaux
• Description honnête et précise
• Prix clairement affichés
• Délais de livraison respectés
• Politique d'annulation définie

Les boutiques peuvent être accessibles publiquement via un lien unique (/boutique/votre-slug).`
    },
    {
      title: "12. Propriété intellectuelle",
      content: `• Le contenu que vous publiez vous appartient
• En publiant sur DJAMANN, vous nous accordez une licence d'utilisation pour afficher votre contenu sur la plateforme
• Cette licence est non-exclusive et révocable
• Vous ne pouvez pas utiliser la marque DJAMANN sans autorisation écrite
• Respectez les droits d'auteur et marques déposées d'autrui
• Les projets créés sur DJAMANN appartiennent à leurs créateurs respectifs`
    },
    {
      title: "13. Suspension et résiliation",
      content: `DJAMANN peut suspendre ou résilier votre compte si :
• Vous violez ces conditions d'utilisation
• Vous avez un comportement frauduleux
• Vous nuisez à d'autres utilisateurs ou à la plateforme
• Vous ne payez pas les abonnements ou commissions dues
• Vous créez de faux avis ou de fausses candidatures
• Votre compte reste inactif pendant plus de 24 mois

Vous pouvez supprimer votre compte à tout moment depuis vos paramètres. La suppression est définitive après 30 jours de délai de grâce.`
    },
    {
      title: "14. Limitation de responsabilité",
      content: `DJAMANN ne peut être tenu responsable :
• Des accords conclus entre utilisateurs
• Des litiges entre utilisateurs
• Des pertes financières résultant de collaborations
• De l'inexécution des engagements par un utilisateur
• Des contenus publiés par les utilisateurs
• Des interruptions de service indépendantes de notre volonté

La plateforme est fournie "en l'état". Nous nous efforçons d'assurer une disponibilité de 99% mais ne garantissons pas un fonctionnement ininterrompu. Des maintenances peuvent être programmées avec préavis.`
    },
    {
      title: "15. Modifications des conditions",
      content: `DJAMANN peut modifier ces conditions à tout moment pour :
• S'adapter aux évolutions légales
• Introduire de nouvelles fonctionnalités
• Améliorer la protection des utilisateurs

Les utilisateurs seront notifiés des changements importants par :
• Email
• Notification dans l'application
• Bannière sur le site

L'utilisation continue de la plateforme après modification vaut acceptation des nouvelles conditions. Vous pouvez refuser les modifications en supprimant votre compte.`
    },
    {
      title: "16. Droit applicable et litiges",
      content: `Ces conditions sont régies par les lois de la République de Côte d'Ivoire.

En cas de litige :
1. Contact du support DJAMANN
2. Tentative de médiation amiable
3. Recours aux tribunaux compétents d'Abidjan

Délai de prescription : 2 ans à compter du fait générateur du litige.`
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Retour
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <img src="/logo.png" alt="DJAMANN" className="w-12 h-12 rounded-xl" />
            <h1 className="text-3xl font-bold">Conditions d'Utilisation</h1>
          </div>
          <p className="text-white/80">
            Dernière mise à jour : {lastUpdate}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* Introduction */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
          <p className="text-gray-600 leading-relaxed">
            Bienvenue sur <strong>DJAMANN</strong> ! Ces conditions d'utilisation régissent votre accès et utilisation de notre plateforme. 
            DJAMANN est une plateforme innovante qui permet à chacun de lancer son business, de collaborer avec d'autres entrepreneurs, 
            et de développer son activité, même sans disposer de moyens financiers ou matériels initiaux.
          </p>
          <div className="mt-6 p-4 bg-indigo-50 rounded-xl">
            <p className="text-indigo-700 text-sm font-medium">
              💡 Conseil : Lisez attentivement ces conditions. En créant un compte, vous confirmez les avoir lues et acceptées.
            </p>
          </div>
        </div>

        {/* Table of contents */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-lg font-bold text-gray-800 mb-4">📑 Sommaire</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {sections.map((section, index) => (
              <button
                key={index}
                onClick={() => setExpandedSection(index)}
                className="text-left px-3 py-2 text-sm text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
              >
                {section.title}
              </button>
            ))}
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div 
              key={index}
              id={`section-${index}`}
              className={`bg-white rounded-2xl shadow-sm border transition-all duration-300 ${
                expandedSection === index ? 'border-indigo-300 shadow-md' : 'border-gray-100 hover:shadow-md'
              }`}
            >
              <button
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                className="w-full p-8 text-left flex items-center justify-between gap-4"
              >
                <h2 className="text-xl font-bold text-gray-800 flex items-center gap-3">
                  <span className="w-8 h-8 bg-indigo-100 text-indigo-600 rounded-lg flex items-center justify-center text-sm font-bold">
                    {index + 1}
                  </span>
                  {section.title.replace(/^\d+\.\s*/, '')}
                </h2>
                <svg 
                  className={`w-5 h-5 text-gray-400 transition-transform ${expandedSection === index ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${expandedSection === index ? 'max-h-[2000px]' : 'max-h-0'}`}>
                <div className="px-8 pb-8 text-gray-600 leading-relaxed whitespace-pre-line">
                  {section.content}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 mb-6">
            En utilisant DJAMANN, vous acceptez ces conditions d'utilisation.
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            <Link 
              to="/privacy" 
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors font-medium"
            >
              🔒 Politique de confidentialité
            </Link>
            <Link 
              to="/guide" 
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-colors font-medium"
            >
              📖 Guide utilisateur
            </Link>
            <Link 
              to="/register" 
              className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-colors font-medium"
            >
              🚀 Créer un compte
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
